import React from "react";
import style from "./style.module.scss";

type TypeCardType = {
  title: string;
  path?: string;
  id: string;
  onClick?: (key: string) => void;
  children?: React.ReactNode;
};

export const TypeCard = ({ id, title, onClick, children }: TypeCardType) => {
  const handleNavigate = (idToNavigate: string) => {
    onClick && onClick(idToNavigate);
  };

  return (
    <div
      className={style.type_card__wrapper}
      onClick={() => handleNavigate(id)}
    >
      {children}
      <div className="">
        <span className={style.type_card__title}> {title} </span>
      </div>
    </div>
  );
};
